import bgPlaceholder from 'assets/images/microbe-paper.svg';
import { ImageFallback, Typography } from 'components';
import VideoResource from 'types/VideoResource';

import { getYouTubeThumbnail } from '../VideoResources.helpers';
import { TinyPlusBadge } from './TinyPlusBadge';
import styles from './Webinars.module.css';

interface VideoCardProps {
  video: VideoResource;
  onSelect: (video: VideoResource) => void;
}

// A row in the side list. Selection (including the locked/upsell path) is
// decided by the parent — the card just reports the click.
export const VideoCard = ({ video, onSelect }: VideoCardProps) => (
  <div className={styles.videoCard} onClick={() => onSelect(video)}>
    <div className={styles.videoThumbnail}>
      <ImageFallback
        src={video.thumbnail_url}
        fallback={getYouTubeThumbnail(video.video_url) || bgPlaceholder}
      />
    </div>
    <div className={styles.videoInfo}>
      <Typography variant='body-s'>{video.short_title}</Typography>
      {video.is_tiny_plus_only ? <TinyPlusBadge /> : null}
    </div>
  </div>
);
